import { render } from "./SearchElement.vue?vue&type=template&id=87467572&scoped=true"
import script from "./SearchElement.vue?vue&type=script&lang=js"
export * from "./SearchElement.vue?vue&type=script&lang=js"

import "./SearchElement.vue?vue&type=style&index=0&id=87467572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87467572"]])

export default __exports__